import React, { useState } from 'react'
import './appointment.css'
import { send } from 'emailjs-com';

function Appointment() {
 
  const [toSend, setToSend] = useState({
    fullname: '',
    rollnum:'',
    gender:'',
    department:'',
    date:'',
    time:'',
    number:'',
    email:'',
    fa:'',
    message:''
  });
  const onSubmit = (e) => {
    e.preventDefault();
    send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      toSend,
      process.env.REACT_APP_EMAILJS_USER_ID
    )
      .then((response) => {
        alert("Success");
      })
      .catch((err) => {
        alert('FAILED...', err);
      });
  };
  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };
  return (
    <div className="appointment">
      <div className="appointment-heading">
        <h1>
          Appointment
        </h1>
      </div>
      <div className="appointment-form">
        <form onSubmit={onSubmit}>

          <div className="appointment-form-details">
            <p>Name</p>
            <input
              type="text"
              placeholder="Enter your Name"
              name="fullname"
              value={toSend.fullname}
              onChange={handleChange}
              required />
          </div>

          <div className="appointment-form-details">
            <p>Roll Number</p>
            <input
              type="text"
              placeholder="Enter your Roll Number"
              name="rollnum"
              value={toSend.rollnum}
              onChange={handleChange}
              required />
          </div>

          <div className="appointment-form-details">
            <p>Gender</p>
            <input
              type="text"
              placeholder="Gender"
              name="gender"
              value={toSend.gender}
              onChange={handleChange}
              />
          </div>

          <div className="appointment-form-details">
            <p>Department</p>
            <input
              type="text"
              placeholder="Department"
              name="department"
              value={toSend.department}
              onChange={handleChange}
              required />
          </div>

          <div className="appointment-form-details">
            <p>Date</p>
            <input
              type="date"
              placeholder="Convenient Date"
              name="date"
              value={toSend.date}
              onChange={handleChange}
               />
          </div>

          <div className="appointment-form-details">
            <p>Time</p>
            <input
              type="time"
              placeholder="Convenient Time"
              name="time"
              value={toSend.time}
              onChange={handleChange}
               />
          </div>

          <div className="appointment-form-details">
            <p>Contact Number</p>
            <input
              type="number"
              placeholder="Contact Number"
              name="number"
              value={toSend.number}
              onChange={handleChange}
              required />
          </div>

          <div className="appointment-form-details">
            <p>Email ID</p>
            <input
              type="email"
              placeholder="Email ID"
              name="email"
              value={toSend.email}
              onChange={handleChange}
              required />
          </div>

          <div className="appointment-form-details">
            <p>FA</p>
            <input
              type="text"
              placeholder="Faculty Advisor Name"
              name="fa"
              value={toSend.fa}
              onChange={handleChange}
              required />
          </div>

          <div className="appointment-form-details">
            <p>Message</p>
            <input
              type="text"
              placeholder="Leave us your Message"
              name="message"
              value={toSend.message}
              onChange={handleChange}
               />
          </div>
          {/* { data.map((item)=>(
          <div key={item.id} className="appointment-form-details">
            <p>{item.title}</p>
          <input 
          type={item.type} 
          placeholder={item.placeholder} 
          name={item.name}
          required/>          
          </div>
          ))
          } */}
          <div className="appointment-form-submit">
            {/* <p>{item.title}</p> */}
            <button type="submit" placeholder="Submit" >Submit Entry</button>

          </div>
        </form>
      </div>
    </div>
  )
}

export default Appointment